import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAnMXHuo75SHcGnE_IYlM1eC6gEuidoGIg",
  authDomain: "mednavigator-ai.firebaseapp.com",
  projectId: "mednavigator-ai",
  storageBucket: "mednavigator-ai.firebasestorage.app",
  messagingSenderId: "871129681138",
  appId: "1:871129681138:web:66006c005a7f7da42e946b",
  measurementId: "G-C3SW2BLKS5"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
